import importScript from "../../helpers/hooks/importScript";
import React, { useEffect, useRef } from "react";
import { EventEmitter } from "fbemitter";
import "./index.scss";

const emitter = new EventEmitter();

interface Props {
  videoId: string;
  width?: number | string | null;
  height?: number | string | null;
  partnerName?: string | null;
  partnerDomain?: string | null;
  autoPlay?: boolean;
  wrap?: boolean;
  type?: "" | "playlist";
}

const VideoPlayer = ({
  videoId,
  width = "auto",
  height = "auto",
  partnerName = "www.olympics.com",
  partnerDomain = "www.olympics.com",
  wrap = true,
  type = ""
}: Props) => {
  const ref = useRef(null);
  importScript(
    "https://www.olympicchannel.com/static/js/syndicated/v1/embed.js",
    () => {
      emitter.emit("scriptLoaded", { id: `${videoId}` });
    }
  );

  const loadVideo = ({
    preload = true,
    _id
  }: {
    preload?: true;
    _id: string;
  }) => {
    emitter.addListener("scriptLoaded", ({ id }: { id: string }) => {
      // @ts-ignore
      var player = new OLYMPIC_CHANNEL.Syndicated(videoId, {
        dimensions: [width, height],
        id: `videoPlayer__${preload ? _id : id}`,
        partnerName,
        type,
        partnerDomain
      });
    });
  };

  useEffect(() => {
    // @ts-ignore
    if (!window.OLYMPIC_CHANNEL) {
      loadVideo({ _id: videoId });
    } else {
      emitter.emit("scriptLoaded", { id: `${videoId}` });
    }
  });

  return wrap ? (
    <div className="page-section section olym-video__container">
      <div className="container">
        <div
          ref={ref}
          className={`olym-video${type == "playlist" ? " playlist" : ""}`}
          id={`videoPlayer__${videoId}`}
        />
      </div>
    </div>
  ) : (
    <div
      ref={ref}
      className={`olym-video${type == "playlist" ? " playlist" : ""}`}
      id={`videoPlayer__${videoId}`}
    />
  );
};

export default VideoPlayer;
